import { render } from "./BannerComponent.vue?vue&type=template&id=7465ff14&scoped=true"
import script from "./BannerComponent.vue?vue&type=script&lang=js"
export * from "./BannerComponent.vue?vue&type=script&lang=js"

import "./BannerComponent.vue?vue&type=style&index=0&id=7465ff14&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7465ff14"]])

export default __exports__